<template>
	<DialogFormDialog ref="dialog" class="form" :strings="strings" @reset="reset">
		<div class="form-row">
			<span>If device</span>
			<v-select
				v-model="selectedDevice"
				:items="devicesWithEvents"
				:rules="rules"
				@change="values.path = null"
			/>
		</div>
		<div class="form-row">
			<span>Fires event</span>
			<v-select v-model="values.path" :items="events" :rules="rules" />
		</div>
	</DialogFormDialog>
</template>

<style lang="scss" scoped>
.form-row {
	display: grid;
	grid-template-columns: minmax(100px, auto) auto;
	grid-template-rows: 1fr;
	place-items: center stretch;

	span {
		font-weight: bold;
		margin-right: 12px;
	}
}
</style>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

const initData = () => ({
	selectedDevice: null,
	values: {
		guid: null,
		path: null,
		operator: "==",
		value: "fired",
	},
});

export default {
	data: initData,

	computed: {
		strings() {
			const _strings = strings.live.scenes.eventConditionDialog;
			return this.values.guid ? _strings.update : _strings.new;
		},
		rules() {
			return [(val) => !!val || "Required"];
		},

		devicesWithEvents() {
			return _.map(
				this.$store.getters["controller/nodes/devicesByType"]("events"),
				(node) => ({
					text: _.startCase(
						`${node.path.split("/").reverse()[1]} ${node.name}`
					),
					value: node,
				})
			);
		},

		events() {
			if (!this.selectedDevice) return [];

			const devicePath = this.selectedDevice.path;
			let events = _.get(this.selectedDevice, "events", []);
			events = _.keys(events);
			events = _.map(events, (eventName) => ({
				text: _.startCase(eventName),
				value: `${devicePath}/events/${eventName}`,
			}));
			return events;
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, node) {
			if (node) {
				this.values.guid = node.guid;
				this.values.path = node.targetPath;
				this.values.operator = node.operator;
				this.values.value = node.value;

				// Get selected device from target event
				this.selectedDevice = this.$store.getters[
					"controller/nodes/nodeByGuid"
				](_.get(node, "target.parentDevice.guid"));
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
